import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Loader2 } from "lucide-react";

/**
 * Admin Route Component
 * Redirects to login if not authenticated
 * Redirects to unauthorized if not admin
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Child components to render if admin
 * @returns {React.ReactElement}
 *
 * @example
 * <Route path="/admin" element={
 *   <AdminRoute>
 *     <AdminDashboard />
 *   </AdminRoute>
 * } />
 */
export const AdminRoute = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="w-12 h-12 animate-spin text-primary" />
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Redirect to unauthorized if not admin
  if (user?.user_role !== 'admin') {
    return <Navigate to="/unauthorized" replace />;
  }

  // User is authenticated and is admin, render the protected component
  return children;
};

